import { styled } from "@mui/material";
import Grid from "@mui/material/Grid";
import ReadonlyFeeScheduleCategoriesTable from "_shared/fee-schedules/categories/_views/readonly-fee-schedule-categories-table";
import FeeScheduleCategory from "_shared/fee-schedules/categories/fee-schedule-category";
import { FeeScheduleCategoryMaskedCurrency, Masked } from "work/_shared/masked-fields";
import CommentThread from "work/proposals/comments/threads/comment-thread";
import Proposal from "work/proposals/proposal";
import ProposalField from "work/proposals/proposal-fields/proposal-field";

const ListContainer = styled(Grid)(({ theme }) => ({
  height: "100%",
  marginLeft: theme.spacing(-3),
  marginTop: theme.spacing(-3),
  minHeight: "20rem",
}));
const CategorySelection = styled(ReadonlyFeeScheduleCategoriesTable)(() => ({
  height: "100%",
}));

type FeeScheduleTabProps = {
  proposal: Proposal;
  commentThreads?: CommentThread[];
  onCommentsClicked: (field: ProposalField, name?: string) => void;
};

export default function FeeScheduleTab(props: Readonly<FeeScheduleTabProps>) {
  const { proposal, commentThreads, onCommentsClicked } = props;

  const selectedCategories: FeeScheduleCategory[] | FeeScheduleCategoryMaskedCurrency[] = Masked.isPresentNotMasked(proposal.feeSchedule) ? proposal.feeSchedule : [];


  if (Masked.isMasked(proposal.feeSchedule)) {
    return "You do not have permission to view the fee schedule.";
  }
  if (Masked.isMasked(proposal.feeSchedule)) {
    return "You do not have permission to view the fee schedule.";
  }

  return (
    <ListContainer container direction="row">
      <Grid size="grow">
        <CategorySelection
          categories={selectedCategories}
          commentThreads={commentThreads}
          onCommentsClicked={onCommentsClicked}
        />
      </Grid>
    </ListContainer>
  );
}
